export default __webpack_public_path__ + "static/media/ecofitness.loader.fa1f3882.gif";